// POC1
import React, { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { DestructiveConfirmButton, ConfirmButton, CancelButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import s from './ConfirmationModal.scss';
const ConfirmationModal = ({ isOpen =false , title , text , icon , withCancelButton =true , cancelBtnLabel , cancelBtnBiData , confirmBtnLabel , confirmBtnType ='default' , confirmBtnBiData , onCancel , onConfirm , onRequestClose , doNotShowAgainKey , onDoNotShowAgainChange , autoAcceptForDoNotShow  })=>{
    const { t  } = useTranslation();
    const isMobile = useContext(MobileContext);
    const doNotShowHandler = useCallback((value)=>{
        if (!doNotShowAgainKey) {
            return;
        }
        onDoNotShowAgainChange && onDoNotShowAgainChange(doNotShowAgainKey, value);
    }, [
        doNotShowAgainKey,
        onDoNotShowAgainChange
    ]);
    useEffect(()=>{
        if (onConfirm && isOpen && autoAcceptForDoNotShow === true) {
            onConfirm();
        }
    }, [
        isOpen,
        autoAcceptForDoNotShow,
        onConfirm
    ]);
    if (autoAcceptForDoNotShow) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(MessageModal, {
        isOpen: isOpen,
        title: title,
        message: text,
        className: s['root'],
        variant: isMobile ? 'vertical' : 'horizontal',
        image: icon,
        footerButtons: [
            withCancelButton && /*#__PURE__*/ React.createElement(CancelButton, {
                key: "cancel",
                onClick: onCancel,
                biData: cancelBtnBiData
            }, cancelBtnLabel !== null && cancelBtnLabel !== void 0 ? cancelBtnLabel : t('popup.cancel')),
            confirmBtnType === 'danger' ? /*#__PURE__*/ React.createElement(DestructiveConfirmButton, {
                key: "danger-confirm",
                onClick: onConfirm,
                biData: confirmBtnBiData
            }, confirmBtnLabel) : /*#__PURE__*/ React.createElement(ConfirmButton, {
                key: "confirm",
                onClick: onConfirm,
                biData: confirmBtnBiData
            }, confirmBtnLabel)
        ],
        onRequestClose: onRequestClose || onCancel || onConfirm,
        doNotShowAgainText: t('popup.doNotShowAgain'),
        onDoNotShowAgainChange: doNotShowAgainKey ? doNotShowHandler : undefined
    });
};
ConfirmationModal.displayName = 'ConfirmationModal';
export default ConfirmationModal;
